import { AuthGuard } from './guards/auth.guard';
import { GuestGuard } from './guards/guest.guard';
import { FitLoginComponent } from './fit-login/fit-login.component';
import { Routes } from '@angular/router';
import { FALLBACK_ROUTE, ROUTE_ACCESS, USER_ROLES } from './auth/route-access';

import { FullComponent } from './layouts/full/full.component';

export const AppRoutes: Routes = [
  {
    path: 'login',
    component: FitLoginComponent,
    canActivate: [GuestGuard],
  },
  {
    path: '',
    component: FullComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: { roles: USER_ROLES },
    children: [
      {
        path: '',
        data: { roles: USER_ROLES },
        loadChildren: () => import('./material-component/material.module').then(m => m.MaterialComponentsModule),
      },
      {
        path: 'check-in-catalog',
        loadChildren: () =>
          import('./material-component/check-in-catalog/check-in-catalog.routes').then(m => m.CHECK_IN_CATALOG_ROUTES),
        data: { roles: ROUTE_ACCESS['check-in-catalog'] },
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: '**',
    redirectTo: FALLBACK_ROUTE,
  },
];
